import { REGEX_CONSTANT } from "../../../constant/regexConstant";

export const validParameter = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "char_value":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "char_value_i":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data > 100) {
        error[namespace] = translate("Max length 100", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("COMMON:WRONGPATTERN_INTEGER", {
          field: translate("GEOTREE:FIELD_NAME"),
        });
      }else if (data<=0) {
        error[namespace] = translate("Value must be more than 0", {
          field: translate("GEOTREE:FIELD_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "char_value_c":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else if (data.length > 8) {
        error[namespace] = translate("Max length 8 Character", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "char_value_f":
          if (!data) {
            error[namespace] = translate("COMMON:REQUIRE", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          }else if(data > 100){
            error[namespace] = translate("Max length 100", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          }else if (!REGEX_CONSTANT.FLOAT.test(data)) {
            error[namespace] = translate("COMMON:WRONGPATTERN_INTEGER", {
              field: translate("GEOTREE:FIELD_NAME"),
            });
          }else if (data<=0) {
            error[namespace] = translate("Value must be more than 0", {
              field: translate("GEOTREE:FIELD_NAME"),
            });
          } else {
            error[namespace] = null;
          }
          break;
    default:
      break;
  }
  return error;
};
